import { get, post } from '@/utils/request/mAxios';
import APIs from './index';
import { CommonList, UserRole } from '@/typings/common';
import { ServiceListItem, ServiceMember, SearchGlobalQuery } from '@/pages/home/type/serviceManage';

export function getServiceList(params: {
  page: number;
  pageSize: number;
  teamId: string;
}) {
  return get<CommonList<'serviceList', ServiceListItem>>(APIs.getServiceList, { ...params });
}

export function queryPsm(prefix: string) {
  return get<{psmList: string[]}>(APIs.queryPsm, { prefix });
}

export function createServiceGroup(data: {
  name: string;
  description: string;
  psm: string;
  business: string;
}) {
  return post(APIs.createGroup, { ...data });
}

export function editServiceGroup(data: {
  name: string;
  serviceId: string;
  description: string;
  psm: string;
  business: string;
}) {
  return post(APIs.editGroup, { ...data });
}

export function getMemberList(params: {
  serviceId: string;
  page?: number;
  pageSize?: number;
}) {
  return get<CommonList<'memberList', ServiceMember>>(APIs.getMemberList, { ...params });
}

export function addGroupMember(data: {
  email: string;
  role: UserRole;
  serviceId: string;
}) {
  return post(APIs.addMember, { ...data });
}

export function editGroupMember(data: {
  role: UserRole;
  serviceId: string;
  email: string;
}) {
  return post(APIs.editMember, { ...data });
}

export function deleteGroupMember(data: {
  email: string;
  serviceId: string;
}) {
  return post(APIs.deleteMember, { ...data });
}

export function getBusinessList() {
  return get(APIs.getBusinessList);
}

export function deleteDocPlatform(data: {
  serviceId: string;
}) {
  return post(APIs.deleteGroup, data);
}

export function searchGlobal(param: SearchGlobalQuery) {
  return get(APIs.searchGlobal, param);
}
